import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';

@Component({
    selector: 'app-ioffer-main',
    templateUrl: './ioffer-main.component.html',
    styleUrls: ['./ioffer-main.component.scss']
})
export class IofferMainComponent implements OnInit, OnDestroy {


    constructor(private renderer: Renderer2) {
        this.renderer.addClass(document.documentElement, 'ioffer');
    }


    ngOnDestroy() {
        this.renderer.removeClass(document.documentElement, 'ioffer');
    }

    ngOnInit(): void {
    }


    confirm() {
    }
}
